import { IGetQuestionsWebResponse } from '../../repositories/newbuilding-reviews/entities/get_questions_web/GetQuestionsWebResponse';
import { IMappedQuestionsResponse } from '../../types/questions/questions';

export const prepareQuestions = (response: IGetQuestionsWebResponse): IMappedQuestionsResponse => {
  const { questions, answers } = response.questions.reduce(
    (acc, question) => {
      const { answers, answerIds } = (question.answers || []).reduce(
        (acc, el) => ({
          answers: {
            ...acc.answers,
            [el.id]: { ...el, questionId: question.id },
          },
          answerIds: [...acc.answerIds, el.id],
        }),
        { answers: {}, answerIds: [] },
      );

      return {
        questions: {
          allIds: [...acc.questions.allIds, question.id],
          byId: {
            ...acc.questions.byId,
            [question.id]: {
              ...question,
              answers: answerIds,
              areAnswersOpened: !!answerIds.length,
              answersPage: 0,
            },
          },
        },
        answers: {
          ...acc.answers,
          ...answers,
        },
      };
    },
    {
      questions: { allIds: [], byId: {} },
      answers: {},
    },
  );

  return {
    ...response,
    questions,
    answers,
  };
};
